import { Component, OnDestroy, OnInit } from '@angular/core'
import { NotifyUserService } from "./notify-user.service"
import { INotifyUserEventModel } from "./notify-user-event.model"
import { Subscription } from "rxjs"
import { NzNotificationService } from "ng-zorro-antd/notification"

@Component({
  selector: 'app-notify-user',
  standalone: false,
  templateUrl: './notify-user.component.html',
})
export class NotifyUserComponent implements OnInit, OnDestroy {

  private _event: INotifyUserEventModel = null
  private _subscription: Subscription = null

  public get event(): INotifyUserEventModel {
    return this._event
  }

  public constructor(
    private service: NotifyUserService,
    private notificationService: NzNotificationService
  ) {
  }

  public onClick(): void {
    switch (this._event?.type) {
      case 'info':
        this.notificationService.info(this._event.title, this._event.message)
        break
      case 'warning':
        this.notificationService.warning(this._event.title, this._event.message)
        break
      case 'success':
        this.notificationService.success(this._event.title, this._event.message)
        break
      case 'error':
        this.notificationService.error(this._event.title, this._event.message)
        break
    }
    this._event = null
  }

  public ngOnInit(): void {
    this._subscription = this.service.notifyEvent.subscribe((event: INotifyUserEventModel): void => {
      this._event = event
    })
  }

  public ngOnDestroy(): void {
    this._event = null
    this._subscription?.unsubscribe()
  }
}
